import { render, staticRenderFns } from "./ModattaSidenav.vue?vue&type=template&id=2cbcf96b&scoped=true"
import script from "./ModattaSidenav.vue?vue&type=script&lang=js"
export * from "./ModattaSidenav.vue?vue&type=script&lang=js"
import style0 from "./ModattaSidenav.vue?vue&type=style&index=0&id=2cbcf96b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbcf96b",
  null
  
)

export default component.exports